/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfUseRouteImport } from './routes/terms-of-use'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedNavbarRouteImport } from './routes/_authenticated/_navbar'
import { Route as AuthenticatedNavbarIndexRouteImport } from './routes/_authenticated/_navbar/index'
import { Route as AuthenticatedNavbarUploadAnalytesRouteImport } from './routes/_authenticated/_navbar/upload-analytes'
import { Route as AuthenticatedNavbarOrganizationsRouteImport } from './routes/_authenticated/_navbar/organizations'
import { Route as AuthenticatedNavbarOrganizationSetupRouteImport } from './routes/_authenticated/_navbar/organization-setup'
import { Route as AuthenticatedNavbarListProductsRouteImport } from './routes/_authenticated/_navbar/list-products'
import { Route as AuthenticatedNavbarListAnalytesRouteImport } from './routes/_authenticated/_navbar/list-analytes'
import { Route as AuthenticatedNavbarExperimentsV2RouteImport } from './routes/_authenticated/_navbar/experiments-v2'
import { Route as AuthenticatedNavbarAdminViewRouteImport } from './routes/_authenticated/_navbar/admin-view'
import { Route as AuthenticatedNavbarSplatRouteImport } from './routes/_authenticated/_navbar/$'
import { Route as AuthenticatedNavbarExperimentsRouteRouteImport } from './routes/_authenticated/_navbar/experiments/route'
import { Route as AuthenticatedNavbarExperimentsIndexRouteImport } from './routes/_authenticated/_navbar/experiments/index'
import { Route as AuthenticatedNavbarAnalyteIndexRouteImport } from './routes/_authenticated/_navbar/analyte/index'
import { Route as AuthenticatedNavbarResultsJobIdRouteImport } from './routes/_authenticated/_navbar/results/$jobId'
import { Route as AuthenticatedNavbarLipidgroupBondTypeRouteImport } from './routes/_authenticated/_navbar/lipidgroup/$bondType'
import { Route as AuthenticatedNavbarInterpretive_reportsReportIdRouteImport } from './routes/_authenticated/_navbar/interpretive_reports/$reportId'
import { Route as AuthenticatedNavbarAnalyteAnalyteIdRouteImport } from './routes/_authenticated/_navbar/analyte/$analyteId'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdRouteRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/route'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdIndexRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/index'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdSamplesRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/samples'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdReportsRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/reports'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdMetadataRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/metadata'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/differential-analysis'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdDataQcRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/data-qc'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdChatRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/chat'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdAnalytesRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/analytes'

const TermsOfUseRoute = TermsOfUseRouteImport.update({
  id: '/terms-of-use',
  path: '/terms-of-use',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedNavbarRoute = AuthenticatedNavbarRouteImport.update({
  id: '/_navbar',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNavbarIndexRoute =
  AuthenticatedNavbarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarUploadAnalytesRoute =
  AuthenticatedNavbarUploadAnalytesRouteImport.update({
    id: '/upload-analytes',
    path: '/upload-analytes',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarOrganizationsRoute =
  AuthenticatedNavbarOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarOrganizationSetupRoute =
  AuthenticatedNavbarOrganizationSetupRouteImport.update({
    id: '/organization-setup',
    path: '/organization-setup',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarListProductsRoute =
  AuthenticatedNavbarListProductsRouteImport.update({
    id: '/list-products',
    path: '/list-products',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarListAnalytesRoute =
  AuthenticatedNavbarListAnalytesRouteImport.update({
    id: '/list-analytes',
    path: '/list-analytes',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsV2Route =
  AuthenticatedNavbarExperimentsV2RouteImport.update({
    id: '/experiments-v2',
    path: '/experiments-v2',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarAdminViewRoute =
  AuthenticatedNavbarAdminViewRouteImport.update({
    id: '/admin-view',
    path: '/admin-view',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarSplatRoute =
  AuthenticatedNavbarSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsRouteRoute =
  AuthenticatedNavbarExperimentsRouteRouteImport.update({
    id: '/experiments',
    path: '/experiments',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsIndexRoute =
  AuthenticatedNavbarExperimentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNavbarExperimentsRouteRoute,
  } as any)
const AuthenticatedNavbarAnalyteIndexRoute =
  AuthenticatedNavbarAnalyteIndexRouteImport.update({
    id: '/analyte/',
    path: '/analyte/',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarResultsJobIdRoute =
  AuthenticatedNavbarResultsJobIdRouteImport.update({
    id: '/results/$jobId',
    path: '/results/$jobId',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarLipidgroupBondTypeRoute =
  AuthenticatedNavbarLipidgroupBondTypeRouteImport.update({
    id: '/lipidgroup/$bondType',
    path: '/lipidgroup/$bondType',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarInterpretive_reportsReportIdRoute =
  AuthenticatedNavbarInterpretive_reportsReportIdRouteImport.update({
    id: '/interpretive_reports/$reportId',
    path: '/interpretive_reports/$reportId',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarAnalyteAnalyteIdRoute =
  AuthenticatedNavbarAnalyteAnalyteIdRouteImport.update({
    id: '/analyte/$analyteId',
    path: '/analyte/$analyteId',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdRouteRoute =
  AuthenticatedNavbarExperimentsSampleSetIdRouteRouteImport.update({
    id: '/$sampleSetId',
    path: '/$sampleSetId',
    getParentRoute: () => AuthenticatedNavbarExperimentsRouteRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdIndexRoute =
  AuthenticatedNavbarExperimentsSampleSetIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdRouteRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdSamplesRoute =
  AuthenticatedNavbarExperimentsSampleSetIdSamplesRouteImport.update({
    id: '/samples',
    path: '/samples',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdRouteRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdReportsRoute =
  AuthenticatedNavbarExperimentsSampleSetIdReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdRouteRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdMetadataRoute =
  AuthenticatedNavbarExperimentsSampleSetIdMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdRouteRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRoute =
  AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRouteImport.update(
    {
      id: '/differential-analysis',
      path: '/differential-analysis',
      getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdRouteRoute,
    } as any,
  )
const AuthenticatedNavbarExperimentsSampleSetIdDataQcRoute =
  AuthenticatedNavbarExperimentsSampleSetIdDataQcRouteImport.update({
    id: '/data-qc',
    path: '/data-qc',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdRouteRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdChatRoute =
  AuthenticatedNavbarExperimentsSampleSetIdChatRouteImport.update({
    id: '/chat',
    path: '/chat',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdRouteRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdAnalytesRoute =
  AuthenticatedNavbarExperimentsSampleSetIdAnalytesRouteImport.update({
    id: '/analytes',
    path: '/analytes',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedNavbarIndexRoute
  '/not-found': typeof NotFoundRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/sign-up': typeof SignUpRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/experiments': typeof AuthenticatedNavbarExperimentsRouteRouteWithChildren
  '/$': typeof AuthenticatedNavbarSplatRoute
  '/admin-view': typeof AuthenticatedNavbarAdminViewRoute
  '/experiments-v2': typeof AuthenticatedNavbarExperimentsV2Route
  '/list-analytes': typeof AuthenticatedNavbarListAnalytesRoute
  '/list-products': typeof AuthenticatedNavbarListProductsRoute
  '/organization-setup': typeof AuthenticatedNavbarOrganizationSetupRoute
  '/organizations': typeof AuthenticatedNavbarOrganizationsRoute
  '/upload-analytes': typeof AuthenticatedNavbarUploadAnalytesRoute
  '/experiments/$sampleSetId': typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRouteWithChildren
  '/analyte/$analyteId': typeof AuthenticatedNavbarAnalyteAnalyteIdRoute
  '/interpretive_reports/$reportId': typeof AuthenticatedNavbarInterpretive_reportsReportIdRoute
  '/lipidgroup/$bondType': typeof AuthenticatedNavbarLipidgroupBondTypeRoute
  '/results/$jobId': typeof AuthenticatedNavbarResultsJobIdRoute
  '/analyte/': typeof AuthenticatedNavbarAnalyteIndexRoute
  '/experiments/': typeof AuthenticatedNavbarExperimentsIndexRoute
  '/experiments/$sampleSetId/analytes': typeof AuthenticatedNavbarExperimentsSampleSetIdAnalytesRoute
  '/experiments/$sampleSetId/chat': typeof AuthenticatedNavbarExperimentsSampleSetIdChatRoute
  '/experiments/$sampleSetId/data-qc': typeof AuthenticatedNavbarExperimentsSampleSetIdDataQcRoute
  '/experiments/$sampleSetId/differential-analysis': typeof AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRoute
  '/experiments/$sampleSetId/metadata': typeof AuthenticatedNavbarExperimentsSampleSetIdMetadataRoute
  '/experiments/$sampleSetId/reports': typeof AuthenticatedNavbarExperimentsSampleSetIdReportsRoute
  '/experiments/$sampleSetId/samples': typeof AuthenticatedNavbarExperimentsSampleSetIdSamplesRoute
  '/experiments/$sampleSetId/': typeof AuthenticatedNavbarExperimentsSampleSetIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedNavbarIndexRoute
  '/not-found': typeof NotFoundRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/sign-up': typeof SignUpRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/$': typeof AuthenticatedNavbarSplatRoute
  '/admin-view': typeof AuthenticatedNavbarAdminViewRoute
  '/experiments-v2': typeof AuthenticatedNavbarExperimentsV2Route
  '/list-analytes': typeof AuthenticatedNavbarListAnalytesRoute
  '/list-products': typeof AuthenticatedNavbarListProductsRoute
  '/organization-setup': typeof AuthenticatedNavbarOrganizationSetupRoute
  '/organizations': typeof AuthenticatedNavbarOrganizationsRoute
  '/upload-analytes': typeof AuthenticatedNavbarUploadAnalytesRoute
  '/analyte/$analyteId': typeof AuthenticatedNavbarAnalyteAnalyteIdRoute
  '/interpretive_reports/$reportId': typeof AuthenticatedNavbarInterpretive_reportsReportIdRoute
  '/lipidgroup/$bondType': typeof AuthenticatedNavbarLipidgroupBondTypeRoute
  '/results/$jobId': typeof AuthenticatedNavbarResultsJobIdRoute
  '/analyte': typeof AuthenticatedNavbarAnalyteIndexRoute
  '/experiments': typeof AuthenticatedNavbarExperimentsIndexRoute
  '/experiments/$sampleSetId/analytes': typeof AuthenticatedNavbarExperimentsSampleSetIdAnalytesRoute
  '/experiments/$sampleSetId/chat': typeof AuthenticatedNavbarExperimentsSampleSetIdChatRoute
  '/experiments/$sampleSetId/data-qc': typeof AuthenticatedNavbarExperimentsSampleSetIdDataQcRoute
  '/experiments/$sampleSetId/differential-analysis': typeof AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRoute
  '/experiments/$sampleSetId/metadata': typeof AuthenticatedNavbarExperimentsSampleSetIdMetadataRoute
  '/experiments/$sampleSetId/reports': typeof AuthenticatedNavbarExperimentsSampleSetIdReportsRoute
  '/experiments/$sampleSetId/samples': typeof AuthenticatedNavbarExperimentsSampleSetIdSamplesRoute
  '/experiments/$sampleSetId': typeof AuthenticatedNavbarExperimentsSampleSetIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/not-found': typeof NotFoundRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/sign-up': typeof SignUpRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/_authenticated/_navbar': typeof AuthenticatedNavbarRouteWithChildren
  '/_authenticated/_navbar/experiments': typeof AuthenticatedNavbarExperimentsRouteRouteWithChildren
  '/_authenticated/_navbar/$': typeof AuthenticatedNavbarSplatRoute
  '/_authenticated/_navbar/admin-view': typeof AuthenticatedNavbarAdminViewRoute
  '/_authenticated/_navbar/experiments-v2': typeof AuthenticatedNavbarExperimentsV2Route
  '/_authenticated/_navbar/list-analytes': typeof AuthenticatedNavbarListAnalytesRoute
  '/_authenticated/_navbar/list-products': typeof AuthenticatedNavbarListProductsRoute
  '/_authenticated/_navbar/organization-setup': typeof AuthenticatedNavbarOrganizationSetupRoute
  '/_authenticated/_navbar/organizations': typeof AuthenticatedNavbarOrganizationsRoute
  '/_authenticated/_navbar/upload-analytes': typeof AuthenticatedNavbarUploadAnalytesRoute
  '/_authenticated/_navbar/': typeof AuthenticatedNavbarIndexRoute
  '/_authenticated/_navbar/experiments/$sampleSetId': typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRouteWithChildren
  '/_authenticated/_navbar/analyte/$analyteId': typeof AuthenticatedNavbarAnalyteAnalyteIdRoute
  '/_authenticated/_navbar/interpretive_reports/$reportId': typeof AuthenticatedNavbarInterpretive_reportsReportIdRoute
  '/_authenticated/_navbar/lipidgroup/$bondType': typeof AuthenticatedNavbarLipidgroupBondTypeRoute
  '/_authenticated/_navbar/results/$jobId': typeof AuthenticatedNavbarResultsJobIdRoute
  '/_authenticated/_navbar/analyte/': typeof AuthenticatedNavbarAnalyteIndexRoute
  '/_authenticated/_navbar/experiments/': typeof AuthenticatedNavbarExperimentsIndexRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/analytes': typeof AuthenticatedNavbarExperimentsSampleSetIdAnalytesRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/chat': typeof AuthenticatedNavbarExperimentsSampleSetIdChatRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/data-qc': typeof AuthenticatedNavbarExperimentsSampleSetIdDataQcRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/differential-analysis': typeof AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/metadata': typeof AuthenticatedNavbarExperimentsSampleSetIdMetadataRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/reports': typeof AuthenticatedNavbarExperimentsSampleSetIdReportsRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/samples': typeof AuthenticatedNavbarExperimentsSampleSetIdSamplesRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/': typeof AuthenticatedNavbarExperimentsSampleSetIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/not-found'
    | '/privacy-policy'
    | '/sign-up'
    | '/terms-of-use'
    | '/experiments'
    | '/$'
    | '/admin-view'
    | '/experiments-v2'
    | '/list-analytes'
    | '/list-products'
    | '/organization-setup'
    | '/organizations'
    | '/upload-analytes'
    | '/experiments/$sampleSetId'
    | '/analyte/$analyteId'
    | '/interpretive_reports/$reportId'
    | '/lipidgroup/$bondType'
    | '/results/$jobId'
    | '/analyte/'
    | '/experiments/'
    | '/experiments/$sampleSetId/analytes'
    | '/experiments/$sampleSetId/chat'
    | '/experiments/$sampleSetId/data-qc'
    | '/experiments/$sampleSetId/differential-analysis'
    | '/experiments/$sampleSetId/metadata'
    | '/experiments/$sampleSetId/reports'
    | '/experiments/$sampleSetId/samples'
    | '/experiments/$sampleSetId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/not-found'
    | '/privacy-policy'
    | '/sign-up'
    | '/terms-of-use'
    | '/$'
    | '/admin-view'
    | '/experiments-v2'
    | '/list-analytes'
    | '/list-products'
    | '/organization-setup'
    | '/organizations'
    | '/upload-analytes'
    | '/analyte/$analyteId'
    | '/interpretive_reports/$reportId'
    | '/lipidgroup/$bondType'
    | '/results/$jobId'
    | '/analyte'
    | '/experiments'
    | '/experiments/$sampleSetId/analytes'
    | '/experiments/$sampleSetId/chat'
    | '/experiments/$sampleSetId/data-qc'
    | '/experiments/$sampleSetId/differential-analysis'
    | '/experiments/$sampleSetId/metadata'
    | '/experiments/$sampleSetId/reports'
    | '/experiments/$sampleSetId/samples'
    | '/experiments/$sampleSetId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/not-found'
    | '/privacy-policy'
    | '/sign-up'
    | '/terms-of-use'
    | '/_authenticated/_navbar'
    | '/_authenticated/_navbar/experiments'
    | '/_authenticated/_navbar/$'
    | '/_authenticated/_navbar/admin-view'
    | '/_authenticated/_navbar/experiments-v2'
    | '/_authenticated/_navbar/list-analytes'
    | '/_authenticated/_navbar/list-products'
    | '/_authenticated/_navbar/organization-setup'
    | '/_authenticated/_navbar/organizations'
    | '/_authenticated/_navbar/upload-analytes'
    | '/_authenticated/_navbar/'
    | '/_authenticated/_navbar/experiments/$sampleSetId'
    | '/_authenticated/_navbar/analyte/$analyteId'
    | '/_authenticated/_navbar/interpretive_reports/$reportId'
    | '/_authenticated/_navbar/lipidgroup/$bondType'
    | '/_authenticated/_navbar/results/$jobId'
    | '/_authenticated/_navbar/analyte/'
    | '/_authenticated/_navbar/experiments/'
    | '/_authenticated/_navbar/experiments/$sampleSetId/analytes'
    | '/_authenticated/_navbar/experiments/$sampleSetId/chat'
    | '/_authenticated/_navbar/experiments/$sampleSetId/data-qc'
    | '/_authenticated/_navbar/experiments/$sampleSetId/differential-analysis'
    | '/_authenticated/_navbar/experiments/$sampleSetId/metadata'
    | '/_authenticated/_navbar/experiments/$sampleSetId/reports'
    | '/_authenticated/_navbar/experiments/$sampleSetId/samples'
    | '/_authenticated/_navbar/experiments/$sampleSetId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  NotFoundRoute: typeof NotFoundRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  SignUpRoute: typeof SignUpRoute
  TermsOfUseRoute: typeof TermsOfUseRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-of-use': {
      id: '/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/terms-of-use'
      preLoaderRoute: typeof TermsOfUseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_navbar': {
      id: '/_authenticated/_navbar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedNavbarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_navbar/': {
      id: '/_authenticated/_navbar/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedNavbarIndexRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/upload-analytes': {
      id: '/_authenticated/_navbar/upload-analytes'
      path: '/upload-analytes'
      fullPath: '/upload-analytes'
      preLoaderRoute: typeof AuthenticatedNavbarUploadAnalytesRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/organizations': {
      id: '/_authenticated/_navbar/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedNavbarOrganizationsRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/organization-setup': {
      id: '/_authenticated/_navbar/organization-setup'
      path: '/organization-setup'
      fullPath: '/organization-setup'
      preLoaderRoute: typeof AuthenticatedNavbarOrganizationSetupRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/list-products': {
      id: '/_authenticated/_navbar/list-products'
      path: '/list-products'
      fullPath: '/list-products'
      preLoaderRoute: typeof AuthenticatedNavbarListProductsRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/list-analytes': {
      id: '/_authenticated/_navbar/list-analytes'
      path: '/list-analytes'
      fullPath: '/list-analytes'
      preLoaderRoute: typeof AuthenticatedNavbarListAnalytesRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/experiments-v2': {
      id: '/_authenticated/_navbar/experiments-v2'
      path: '/experiments-v2'
      fullPath: '/experiments-v2'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsV2RouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/admin-view': {
      id: '/_authenticated/_navbar/admin-view'
      path: '/admin-view'
      fullPath: '/admin-view'
      preLoaderRoute: typeof AuthenticatedNavbarAdminViewRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/$': {
      id: '/_authenticated/_navbar/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedNavbarSplatRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/experiments': {
      id: '/_authenticated/_navbar/experiments'
      path: '/experiments'
      fullPath: '/experiments'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsRouteRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/experiments/': {
      id: '/_authenticated/_navbar/experiments/'
      path: '/'
      fullPath: '/experiments/'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsIndexRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsRouteRoute
    }
    '/_authenticated/_navbar/analyte/': {
      id: '/_authenticated/_navbar/analyte/'
      path: '/analyte'
      fullPath: '/analyte/'
      preLoaderRoute: typeof AuthenticatedNavbarAnalyteIndexRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/results/$jobId': {
      id: '/_authenticated/_navbar/results/$jobId'
      path: '/results/$jobId'
      fullPath: '/results/$jobId'
      preLoaderRoute: typeof AuthenticatedNavbarResultsJobIdRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/lipidgroup/$bondType': {
      id: '/_authenticated/_navbar/lipidgroup/$bondType'
      path: '/lipidgroup/$bondType'
      fullPath: '/lipidgroup/$bondType'
      preLoaderRoute: typeof AuthenticatedNavbarLipidgroupBondTypeRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/interpretive_reports/$reportId': {
      id: '/_authenticated/_navbar/interpretive_reports/$reportId'
      path: '/interpretive_reports/$reportId'
      fullPath: '/interpretive_reports/$reportId'
      preLoaderRoute: typeof AuthenticatedNavbarInterpretive_reportsReportIdRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/analyte/$analyteId': {
      id: '/_authenticated/_navbar/analyte/$analyteId'
      path: '/analyte/$analyteId'
      fullPath: '/analyte/$analyteId'
      preLoaderRoute: typeof AuthenticatedNavbarAnalyteAnalyteIdRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId'
      path: '/$sampleSetId'
      fullPath: '/experiments/$sampleSetId'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/'
      path: '/'
      fullPath: '/experiments/$sampleSetId/'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdIndexRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/samples': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/samples'
      path: '/samples'
      fullPath: '/experiments/$sampleSetId/samples'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdSamplesRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/reports': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/reports'
      path: '/reports'
      fullPath: '/experiments/$sampleSetId/reports'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdReportsRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/metadata': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/metadata'
      path: '/metadata'
      fullPath: '/experiments/$sampleSetId/metadata'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdMetadataRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/differential-analysis': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/differential-analysis'
      path: '/differential-analysis'
      fullPath: '/experiments/$sampleSetId/differential-analysis'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/data-qc': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/data-qc'
      path: '/data-qc'
      fullPath: '/experiments/$sampleSetId/data-qc'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdDataQcRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/chat': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/chat'
      path: '/chat'
      fullPath: '/experiments/$sampleSetId/chat'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdChatRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/analytes': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/analytes'
      path: '/analytes'
      fullPath: '/experiments/$sampleSetId/analytes'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdAnalytesRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRoute
    }
  }
}

interface AuthenticatedNavbarExperimentsSampleSetIdRouteRouteChildren {
  AuthenticatedNavbarExperimentsSampleSetIdAnalytesRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdAnalytesRoute
  AuthenticatedNavbarExperimentsSampleSetIdChatRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdChatRoute
  AuthenticatedNavbarExperimentsSampleSetIdDataQcRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdDataQcRoute
  AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRoute
  AuthenticatedNavbarExperimentsSampleSetIdMetadataRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdMetadataRoute
  AuthenticatedNavbarExperimentsSampleSetIdReportsRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdReportsRoute
  AuthenticatedNavbarExperimentsSampleSetIdSamplesRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdSamplesRoute
  AuthenticatedNavbarExperimentsSampleSetIdIndexRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdIndexRoute
}

const AuthenticatedNavbarExperimentsSampleSetIdRouteRouteChildren: AuthenticatedNavbarExperimentsSampleSetIdRouteRouteChildren =
  {
    AuthenticatedNavbarExperimentsSampleSetIdAnalytesRoute:
      AuthenticatedNavbarExperimentsSampleSetIdAnalytesRoute,
    AuthenticatedNavbarExperimentsSampleSetIdChatRoute:
      AuthenticatedNavbarExperimentsSampleSetIdChatRoute,
    AuthenticatedNavbarExperimentsSampleSetIdDataQcRoute:
      AuthenticatedNavbarExperimentsSampleSetIdDataQcRoute,
    AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRoute:
      AuthenticatedNavbarExperimentsSampleSetIdDifferentialAnalysisRoute,
    AuthenticatedNavbarExperimentsSampleSetIdMetadataRoute:
      AuthenticatedNavbarExperimentsSampleSetIdMetadataRoute,
    AuthenticatedNavbarExperimentsSampleSetIdReportsRoute:
      AuthenticatedNavbarExperimentsSampleSetIdReportsRoute,
    AuthenticatedNavbarExperimentsSampleSetIdSamplesRoute:
      AuthenticatedNavbarExperimentsSampleSetIdSamplesRoute,
    AuthenticatedNavbarExperimentsSampleSetIdIndexRoute:
      AuthenticatedNavbarExperimentsSampleSetIdIndexRoute,
  }

const AuthenticatedNavbarExperimentsSampleSetIdRouteRouteWithChildren =
  AuthenticatedNavbarExperimentsSampleSetIdRouteRoute._addFileChildren(
    AuthenticatedNavbarExperimentsSampleSetIdRouteRouteChildren,
  )

interface AuthenticatedNavbarExperimentsRouteRouteChildren {
  AuthenticatedNavbarExperimentsSampleSetIdRouteRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRouteWithChildren
  AuthenticatedNavbarExperimentsIndexRoute: typeof AuthenticatedNavbarExperimentsIndexRoute
}

const AuthenticatedNavbarExperimentsRouteRouteChildren: AuthenticatedNavbarExperimentsRouteRouteChildren =
  {
    AuthenticatedNavbarExperimentsSampleSetIdRouteRoute:
      AuthenticatedNavbarExperimentsSampleSetIdRouteRouteWithChildren,
    AuthenticatedNavbarExperimentsIndexRoute:
      AuthenticatedNavbarExperimentsIndexRoute,
  }

const AuthenticatedNavbarExperimentsRouteRouteWithChildren =
  AuthenticatedNavbarExperimentsRouteRoute._addFileChildren(
    AuthenticatedNavbarExperimentsRouteRouteChildren,
  )

interface AuthenticatedNavbarRouteChildren {
  AuthenticatedNavbarExperimentsRouteRoute: typeof AuthenticatedNavbarExperimentsRouteRouteWithChildren
  AuthenticatedNavbarSplatRoute: typeof AuthenticatedNavbarSplatRoute
  AuthenticatedNavbarAdminViewRoute: typeof AuthenticatedNavbarAdminViewRoute
  AuthenticatedNavbarExperimentsV2Route: typeof AuthenticatedNavbarExperimentsV2Route
  AuthenticatedNavbarListAnalytesRoute: typeof AuthenticatedNavbarListAnalytesRoute
  AuthenticatedNavbarListProductsRoute: typeof AuthenticatedNavbarListProductsRoute
  AuthenticatedNavbarOrganizationSetupRoute: typeof AuthenticatedNavbarOrganizationSetupRoute
  AuthenticatedNavbarOrganizationsRoute: typeof AuthenticatedNavbarOrganizationsRoute
  AuthenticatedNavbarUploadAnalytesRoute: typeof AuthenticatedNavbarUploadAnalytesRoute
  AuthenticatedNavbarIndexRoute: typeof AuthenticatedNavbarIndexRoute
  AuthenticatedNavbarAnalyteAnalyteIdRoute: typeof AuthenticatedNavbarAnalyteAnalyteIdRoute
  AuthenticatedNavbarInterpretive_reportsReportIdRoute: typeof AuthenticatedNavbarInterpretive_reportsReportIdRoute
  AuthenticatedNavbarLipidgroupBondTypeRoute: typeof AuthenticatedNavbarLipidgroupBondTypeRoute
  AuthenticatedNavbarResultsJobIdRoute: typeof AuthenticatedNavbarResultsJobIdRoute
  AuthenticatedNavbarAnalyteIndexRoute: typeof AuthenticatedNavbarAnalyteIndexRoute
}

const AuthenticatedNavbarRouteChildren: AuthenticatedNavbarRouteChildren = {
  AuthenticatedNavbarExperimentsRouteRoute:
    AuthenticatedNavbarExperimentsRouteRouteWithChildren,
  AuthenticatedNavbarSplatRoute: AuthenticatedNavbarSplatRoute,
  AuthenticatedNavbarAdminViewRoute: AuthenticatedNavbarAdminViewRoute,
  AuthenticatedNavbarExperimentsV2Route: AuthenticatedNavbarExperimentsV2Route,
  AuthenticatedNavbarListAnalytesRoute: AuthenticatedNavbarListAnalytesRoute,
  AuthenticatedNavbarListProductsRoute: AuthenticatedNavbarListProductsRoute,
  AuthenticatedNavbarOrganizationSetupRoute:
    AuthenticatedNavbarOrganizationSetupRoute,
  AuthenticatedNavbarOrganizationsRoute: AuthenticatedNavbarOrganizationsRoute,
  AuthenticatedNavbarUploadAnalytesRoute:
    AuthenticatedNavbarUploadAnalytesRoute,
  AuthenticatedNavbarIndexRoute: AuthenticatedNavbarIndexRoute,
  AuthenticatedNavbarAnalyteAnalyteIdRoute:
    AuthenticatedNavbarAnalyteAnalyteIdRoute,
  AuthenticatedNavbarInterpretive_reportsReportIdRoute:
    AuthenticatedNavbarInterpretive_reportsReportIdRoute,
  AuthenticatedNavbarLipidgroupBondTypeRoute:
    AuthenticatedNavbarLipidgroupBondTypeRoute,
  AuthenticatedNavbarResultsJobIdRoute: AuthenticatedNavbarResultsJobIdRoute,
  AuthenticatedNavbarAnalyteIndexRoute: AuthenticatedNavbarAnalyteIndexRoute,
}

const AuthenticatedNavbarRouteWithChildren =
  AuthenticatedNavbarRoute._addFileChildren(AuthenticatedNavbarRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedNavbarRoute: typeof AuthenticatedNavbarRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedNavbarRoute: AuthenticatedNavbarRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  NotFoundRoute: NotFoundRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  SignUpRoute: SignUpRoute,
  TermsOfUseRoute: TermsOfUseRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
